export const URL_PATTERN = 'https?://.+';
export const ZIP_PATTERN = '[0-9０-９]+[0-9０-９-ー]+[0-9０-９]+';
export const HIRAGANA_PATTERN = '[ぁ-ゔゞ゛゜ー]+';
export const KATAKANA_PATTERN =
  '(?=.*?[\u30A1-\u30FC])[\u30A1-\u30FC\u3000\u0020s]*';
export const BANK_ACCOUNT_NAME_PATTERN =
  '(?=.*?[\u30A1-\u30FC０-９Ａ-Ｚー－（）「」．／゛゜￥])[\u30A1-\u30FC\u3000\u0020s０-９Ａ-Ｚー－（）「」．／゛゜￥]*';
export const NUMBER_PATTERN = '[0-9]+';
export const EMAIL_PATTERN =
  "[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*";
export const TEL_PATTERN = '\\+?[0-9０-９][0-9０-９-−ー]+';
export const PRESENT_PATTERN = '(\\s*[^\\s]+\\s*)+';
export const PASSWORD_PATTERN =
  '(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{<%= Devise.password_length.min %>,}';

export const PRESENT_REGEX = /^(\s*[^\s]+\s*)+$/;

export const DATETIME_FORMAT: string = 'YYYY/MM/DD HH:mm';
export const DATE_FORMAT: string = 'YYYY/MM/DD';
export const JP_DATE_FORMAT = 'YYYY年M月D日';
export const DATE_MONTH_FORMAT: string = 'YYYY/MM';
export const MONTH_DAY_FORMAT: string = 'MM/DD';
export const MONTH_DAY_TIME_FORMAT: string = 'MM/DD HH:mm';
export const TIME_FORMAT: string = 'HH:mm';

export const UPPER_ALPHABETS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];
export const LOWER_ALPHABETS = UPPER_ALPHABETS.map((a) => a.toLowerCase());

// Attributes
export const DESTROY = '_destroy';

export const BANK_ACCOUNT_ATTRIBUTES = 'bank_account_attributes';

export const REVIEW_ATTRIBUTES = 'review_attributes';
export const SECTIONS_ATTRIBUTES = 'sections_attributes';
export const OPTIONS_ATTRIBUTES = 'options_attributes';
export const USER_SKILL_CATEGORIES_ATTRIBUTES =
  'user_skill_categories_attributes';

export const WORKING_TIMES_ATTRIBUTES = 'sections';

export const RESPONSE_ATTRIBUTES = 'response_attributes';

// Enum

export const MALE = 'male';
export const FEMALE = 'female';

export const GENERAL_NOTIFICATION = 'general';
export const NEW_PLAN_NOTIFICATION = 'new_plan';

export const DRIVER_LICENSE = 'driver_license';
export const PASSPORT = 'passport';
export const MY_NUMBER = 'my_number';
export const RESIDENCE_CARD = 'residence_card';

export const FIXED = 'fixed';
export const PENDING = 'pending';

export const SCHEDULE_REQUEST = 'request';
export const SCHEDULE_PENDING = 'pending';
export const SCHEDULE_APPROVED = 'approved';
export const SCHEDULE_REJECTED = 'rejected';

export const TIME_FIXED = 'fixed';
export const TIME_CHANGE = 'change';
export const TIME_DESTROY = 'destroy';

export const NEARBY_HOTEL = 'nearby_hotel';

export const BEDROOM_MALE = 'bedroom_male';
export const BEDROOM_FEMALE = 'bedroom_female';
export const BEDROOM_COMMON = 'bedroom_common';
export const BATHROOM = 'bathroom';
export const APPEARANCE = 'appearance';
export const OTHER = 'other';
export const OTHER_KIND = 'other_kind';
export const OTHER_ROOM_TYPE = 'other_room_type';

// Business Features
export const ANA = 'ana';
export const KYOTANGO = 'kyotango';

export const CERTIFICATE_STATUSES = {
  UNCERTIFIED: 'uncertified',
  CONFIRMING: 'confirming',
  CERTIFIED: 'certified',
  REJECTED: 'rejected',
};

export const ONGOING = 'ongoing';
export const WORKING = 'working';
export const WAITING_BIZ_APPROVAL = 'waiting_biz_approval';
export const WAITING_USER_APPROVAL = 'waiting_user_approval';
export const APPROVED = 'approved';
export const APPROVAL = 'approval';
export const PAID = 'paid';
export const REVIEW = 'review';

// LINEアプリ内ブラウザから強制的にブラウザアプリを開くためのパラメータ
// https://developers.line.biz/ja/docs/messaging-api/using-line-url-scheme/#available-line-url-schemes
export const OPEN_EXTERNAL_BROWSER_QUERY = 'openExternalBrowser=1';

export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet';
export const LINE_SHARE_URL = 'https://social-plugins.line.me/lineit/share';
